export default "__VITE_ASSET__6ea846af__"